import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Panel } from "components/bootstrap";
import styles from "./TemplateFieldValueProviderPreview.css";
const TemplateFieldValueProviderPreview = () => {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement(Panel, { className: styles.templatePreview, header: /* @__PURE__ */ React.createElement("h3", null, t("template_preview.title")) }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "template_preview.description",
      values: { syntax: "${source.<fieldName>}" },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ), /* @__PURE__ */ React.createElement("br", null), t("template_preview.available_fields")), /* @__PURE__ */ React.createElement("ul", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, t("template_preview.filter_label")), " ", t("template_preview.filter")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, t("template_preview.aggregation_label")), " ", t("template_preview.aggregation")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, t("template_preview.correlation_label")), " ", t("template_preview.correlation"))));
};
export default TemplateFieldValueProviderPreview;
